import PageHeader from '../components/layout/PageHeader';
import SplitSection from '../components/layout/SplitSection';
import usePageTitle from '../hooks/usePageTitle';

export default function About() {
  usePageTitle('About Us');

  return (
    <>
      <PageHeader eyebrow="About Us" title="Who Are We?" />

      <SplitSection
        id="who-we-are"
        image="images/about/1.png"
        imageAlt="Paw Global Veterinary staff examining a cat on the treatment table"
        aspectRatio="1 / 1"
      >
        <p>
          <strong>Paw Global Veterinary</strong>, a proud division of{' '}
          <strong>J&amp;JP Global Co. Ltd.</strong>, was established on{' '}
          <strong>15 July 2025</strong> to serve as the trusted veterinary care partner for pet
          owners in Phnom Penh. We offer a holistic suite of services designed to meet the full
          spectrum of your pets’ needs—ensuring their health, happiness, and well-being.
        </p>
        <p>
          <strong>Our values</strong> are <strong>honesty</strong>, <strong>humility</strong>, and{' '}
          <strong>hard work</strong> in everything we do.
        </p>
        <p>
          <strong>Our mission</strong> is to deliver comprehensive, compassionate, and expert
          veterinary care that promotes pet well-being and empowers pet owners, in alignment with
          our organizational values.
        </p>
        <p>
          <strong>Our vision</strong> is to be the leading trusted veterinary service provider in
          Asia, distinguished by excellence, ethical leadership, and sustained contributions to the
          regional pet care ecosystem.
        </p>
      </SplitSection>

      <SplitSection
        id="collaboration"
        title="Our Collaboration"
        eyebrow="Partnerships"
        image="images/about/2.png"
        imageAlt="Crest of the Royal University of Agriculture"
        aspectRatio="1 / 1"
        mediaFit="contain"
        reverse
        tinted
      >
        <p>
          Paw Global Veterinary signed a MOU with the Royal University of Agriculture in June 2025
          to provide internship opportunities, scholarships, job placements, clinical training, and
          diagnostic collaboration to benefit veterinary students, graduates and the University.
        </p>
        <p>
          We are thankful for several partners who came alongside us to provide the required
          support to the university and their students.
        </p>
      </SplitSection>
    </>
  );
}
